import React from 'react';
import PropTypes from 'prop-types';

function Open(props) {
    return (
        <span
            onClick={props.onClick}
            className="catalog-filter-section__action catalog-filter-section__action--open"
        />
    );
}

Open.propTypes = {
    onClick: PropTypes.func.isRequired
};

export { Open };
